var render = function render(){var _vm=this,_c=_vm._self._c;return _c('payout-limits',{attrs:{"limits":_vm.limits,"entities":_vm.entities,"is-loading":_vm.isLoading},on:{"reload":_vm.loadLimits,"save":function($event){return _vm.update($event)},"delete":_vm.onDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }